<template><section>
<h2 id="dialog-zu-jian"><a class="header-anchor" href="#dialog-zu-jian" aria-hidden="true">¶</a> Dialog组件</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa" aria-hidden="true">¶</a> 基础用法</h3>
<pre><code class="hljs language-html"><span class="hljs-tag">&lt;<span class="hljs-name">zan-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleAlertClick"</span>&gt;</span>alert<span class="hljs-tag">&lt;/<span class="hljs-name">zan-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">zan-button</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"handleConfirmClick"</span>&gt;</span>confirm<span class="hljs-tag">&lt;/<span class="hljs-name">zan-button</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Dialog } <span class="hljs-keyword">from</span> <span class="hljs-string">'src/index'</span>;

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    handleAlertClick() {
      Dialog.alert({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'alert标题'</span>,
        <span class="hljs-attr">message</span>: <span class="hljs-string">'弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。'</span>
      }).then(<span class="hljs-function">(<span class="hljs-params">action</span>) =&gt;</span> {
        <span class="hljs-built_in">console</span>.log(action);
      });
    },

    handleConfirmClick() {
      Dialog.confirm({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'confirm标题'</span>,
        <span class="hljs-attr">message</span>: <span class="hljs-string">'弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。'</span>
      }).then(<span class="hljs-function">(<span class="hljs-params">action</span>) =&gt;</span> {
        <span class="hljs-built_in">console</span>.log(action);
      }, (error) =&gt; {
        <span class="hljs-built_in">console</span>.log(error);
      });
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<h3 id="api"><a class="header-anchor" href="#api" aria-hidden="true">¶</a> API</h3>
<table class="table"><thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
<th>可选值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题</td>
<td>String</td>
<td>''</td>
<td></td>
</tr>
<tr>
<td>message</td>
<td>内容</td>
<td>String</td>
<td>''</td>
<td></td>
</tr>
</tbody>
</table>
</section></template>

<script>
import { Dialog } from 'src/index';

export default {
  methods: {
    handleAlertClick() {
      Dialog.alert({
        title: 'alert标题',
        message: '弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。'
      }).then((action) => {
        console.log(action);
      });
    },

    handleConfirmClick() {
      Dialog.confirm({
        title: 'confirm标题',
        message: '弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。弹窗提示文字，左右始终距离边20PX，上下距离20PX，文字左对齐。'
      }).then((action) => {
        console.log(action);
      }, (error) => {
        console.log(error);
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// dialog-4.vue?40d959dd